"use client"

import { useState, useEffect } from "react"
import { ChevronDown } from "lucide-react"
import { drinksLeft, drinksRight } from "./images"
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LoginModal from '../oauth/LoginModal';
import { FooterComponents } from './FooterComponents';
import Header from "../LandingPage/Header";



function FAQItem({ question, answer, isOpen, onClick, isFirst, isLast }) {
    return (
        <div className=" ">
            <button
                onClick={onClick}
                className={`w-full drop-shadow-xl text-xl text-left flex items-center justify-between bg-white outline outline-2 outline-[#2b0062] text-[#2b0062] px-4 py-6 hover:bg-opacity-90 transition-colors rounded-lg
              ${isOpen ? "" : ""}
          ${isFirst ? "rounded-t-lg" : ""} 
          ${isLast ? "rounded-b-lg" : ""}`}
            >
                <span className="font-semibold ">{question}</span>
                <ChevronDown className={`h-5 w-5 transition-transform duration-200 ${isOpen ? "transform rotate-180" : ""}`} />
            </button>
            <div
                className={`overflow-hidden bg-[#2b0062] transition-all duration-200 ease-in-out ${isOpen ? "mb-10 mt-3 rounded-lg mx-2 outline outline-2 outline-[#2b0062] max-h-[500px] opacity-80" : "max-h-0 opacity-0"
                    }`}
            >
                <div className="px-4 py-4 text-[#2b0062] md:font-semibold bg-white">{answer}</div>
            </div>
        </div>
    )
}

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null)
    const navigate = useNavigate();
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);


    const handleBack = () => {
        navigate('/', { replace: true });
    };

    // Handle mobile menu scroll lock
    useEffect(() => {
        // Add the "no-scroll" class when the mobile menu is open
        if (isMobileMenuOpen) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }

        // Cleanup when the component unmounts or when isMobileMenuOpen changes
        return () => {
            document.body.classList.remove("no-scroll");
        };
    }, [isMobileMenuOpen]);

    const faqData = [
        {
            question: "What is LastCall?",
            answer:
                "LastCall is an SMS marketing platform built specifically for bars. It helps you easily connect with your patrons by sending personalized deals, event updates, and promotions directly to their phones, driving foot traffic and boosting sales.",
        },
        {
            question: "What is different about LastCall?",
            answer:
                "LastCall is the only SMS marketing platform built specifically for nightlife venues, helping establishments connect with their patrons in real-time. Unlike generic marketing tools, LastCall is designed for the fast-paced nature of nightlife, making it easy to send last-minute promos, event updates, and exclusive deals directly to customers. We don't just provide the platform—we help bars grow their customer list with seamless sign-up tools that maximize opt-ins. Our built-in analytics give bars real insights into campaign performance, allowing them to track engagement that bars want to see and optimize their marketing efforts.",
        },
        {
            question: "How does LastCall work?",
            answer:
                "Bars create an account, and start sending text message campaigns. Patrons opt in to receive messages, and you can send them targeted promotions based on the information you've collected. No complicated setup or extra tools required—just a simple and efficient way to keep your crowd engaged.",
        },
        {
            question: "How do patrons sign up for text messages?",
            answer:
                "Patrons can sign up via a QR code displayed in your bar, on your website, or through promotional materials. Once they opt in, they'll start receiving texts with the latest deals, events, and more. Reach out to our team to inquire what is best for your bar.",
        },
        {
            question: "Can I customize my messages?",
            answer:
                "LastCall allows you to customize your messages to reflect your bar's unique voice, promotions, and events. You can personalize each campaign and schedule messages for maximum impact.",
        },
        {
            question: "How much does LastCall cost?",
            answer:
                "Pricing is based on the number of patrons you want to reach. We offer different pricing tiers to fit the needs of bars of all sizes. Get in touch with us for a personalized quote.",
        },
        {
            question: "Do I need to worry about legal requirements?",
            answer:
                "Nope! LastCall is fully compliant with all SMS marketing regulations, including AD2P (Advertising to People) compliance, and ensures patrons' legal drinking age is verified.",
        },
        {
            question: "Is there a contract or commitment?",
            answer:
                "No long-term commitment required. We offer flexible plans so you can use LastCall as it fits your business needs, with the option to cancel or change plans at any time.",
        },
    ]

    return (
        <div className="overflow-hidden md:overflow-visible relative min-h-screen bg-white overflow-hidden">

            <Header setIsLoginOpen={setIsLoginOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} isMobileMenuOpen={isMobileMenuOpen} />

            {/* Left Side Drinks */}
            <div
                className="absolute left-0 top-24 bottom-0 md:w-24 lg:w-32 hidden md:block -ml-5"
                style={{
                    backgroundImage: `url(${drinksLeft || "/placeholder.svg"})`,
                    backgroundRepeat: 'repeat-y',
                    backgroundSize: 'contain'
                }}
            ></div>

            {/* Right Side Drinks */}
            <div
                className="absolute right-0 top-16 bottom-0 md:w-24 lg:w-32 hidden md:block -mr-5"
                style={{
                    backgroundImage: `url(${drinksRight || "/placeholder.svg"})`,
                    backgroundRepeat: 'repeat-y',
                    backgroundSize: 'contain'
                }}
            ></div>


            {/* Back Button TODO: Fix mobile back button*/}
            <div className="absolute top-2 left-4 flex items-center space-x-4">
                <button
                    onClick={handleBack}
                    className="flex items-center bg-transparent hover:bg-[#2b0062]/10 p-2 rounded-full transition-colors"
                >
                    <ArrowLeft className="w-4 h-4 md:w-10 md:h-10 text-[#2b0062] mr-2" />
                    <span className="text-[#2b0062] text-sm md:text-xl font-semibold">Back</span>
                </button>

            </div>

            {/* <div className="hidden md:block absolute text-xl font-semibold hover:opacity-80 text-[#2b0062] top-6 right-4 flex space-x-6 overflow-hidden">
                <Link to="/about-us" className=" font-semibold hover:opacity-80" onClick={() => window.scrollTo(0, 0)}>About Us</Link>
                <a
                    href="https://calendly.com/emmarosefisher1/30min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold hover:opacity-80"
                >
                    Get a Demo
                </a>
                <a
                    href="https://tally.so/r/wM8JYk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80"
                >
                    Refer a Venue
                </a>
                <button onClick={() => setIsLoginOpen(true)} className="hover:opacity-80">
                    Log In
                </button>
            </div> */}

            <div className="bg-white min-h-screen flex flex-col items-center md:mt-16">
                <div className="w-full md:max-w-2xl lg:max-w-4xl xl:max-w-5xl mx-auto px-4 py-12 bg-white">
                    <h2 className="text-3xl text-[#2b0062] font-bold text-center mb-8">Frequently Asked Questions</h2>
                    <div className="space-y-3">
                        {faqData.map((faq, index) => (
                            <FAQItem
                                key={index}
                                question={faq.question}
                                answer={faq.answer}
                                isOpen={openIndex === index}
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                isFirst={index === 0}
                                isLast={index === faqData.length - 1}
                            />
                        ))}
                    </div>
                </div>
                {/* Mobile Footer */}
            <div className="md:hidden mt-16">
                <FooterComponents isMobile={true} setIsLoginOpen={setIsLoginOpen} />
            </div>

            {/* Desktop Footer */}
            <div className="hidden md:block mt-16">
                <FooterComponents isMobile={false} setIsLoginOpen={setIsLoginOpen} />
            </div>
            </div>
            <LoginModal open={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
        </div>
    )
}

